// This reducer is a no-op, only relying on the initial auth state passed to configureStore()
//
const noop = (state = {}) => state;
export default noop;